import { render } from "./App.vue?vue&type=template&id=8413de9a"
const script = {}

import "./App.vue?vue&type=style&index=0&id=8413de9a&lang=css"

import exportComponent from "/Users/franky/Documents/fugenbild/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__